import { GET_USER_ROLES, GET_USERS_FOR_ROLE, SET_USERS_FOR_ROLE, SET_ROLES_FOR_USER, GET_ROLES_FOR_USER, DELETE_USER_ROLE, UPSERT_USER_ROLE, GET_USER_ROLE } from "../constants/action-types";
import Axios from "axios";

import { getApiConfig } from "../../config/apiConfig";
import { adalApiFetch } from "../../config/azureConfig";
import { UUID } from "../../helpers/uuid";
import NativeSelectInput from "@material-ui/core/NativeSelect/NativeSelectInput";
const API_CONFIG = getApiConfig();

/*
  Get user roles.
*/
export const getUserRoles = callback => dispatch => {
    adalApiFetch(Axios, `${API_CONFIG.URL}/user-roles`, {
        method: "get"
    })
        .then(res => {
            dispatch({
                type: GET_USER_ROLES,
                payload: res.data
            })

            callback(true)
        })
        .catch(error => {
            console.log("Exception occurred", error);
            callback(false);
        });
};


/*
Upsert user role.
*/
export const upsertUserRole = (userRoleName, userRoleId, callback) => dispatch => {
    const newRole = {
        id: userRoleId != null ? userRoleId : undefined,
        DisplayName: userRoleName
    }
    adalApiFetch(Axios, `${API_CONFIG.URL}/user-roles`, {
        method: "post",
        data: newRole
    })
        .then(res => {
            dispatch({
                type: UPSERT_USER_ROLE,
                payload: null
            })
            callback(true)
        })
        .catch(error => {
            console.log("Exception occurred", error);
            callback(false);
        });
};

/*
  Get user role.
*/
export const getUserRole = (roleId, callback) => dispatch => {
    dispatch({
        type: GET_USER_ROLE,
        payload: roleId
    })

    callback(true)
};


/*
  Delete user role.
*/
export const deleteUserRole = (roleId, callback) => dispatch => {
    adalApiFetch(Axios, `${API_CONFIG.URL}/user-roles/${roleId}`, {
        method: "delete"
    })
        .then(res => {
            dispatch({
                type: DELETE_USER_ROLE,
                payload: null
            })

            callback(true)
        })
        .catch(error => {
            console.log("Exception occurred", error);
            callback(false);
        });
};

/*
Create user role.
*/
// export const updateUserRole = (roleId, callback) => dispatch => {
//     adalApiFetch(Axios, `${API_CONFIG.URL}/user-roles`, {
//       method: "get"
//     })
//       .then(res => {
//     dispatch({
//         type: UPDATE_USER_ROLE,
//         payload: null
//     })

//     callback(true)
//       })
//       .catch(error => {
//         console.log("Exception occurred", error);
//         callback(false);
//       });
// };

/*
Get users list for role.
*/
export const getUsersForRole = (roleId, callback) => dispatch => {
    adalApiFetch(Axios, `${API_CONFIG.URL}/user-roles/users/${roleId}`, {
        method: "get"
    })
        .then(res => {
            dispatch({
                type: GET_USERS_FOR_ROLE,
                payload: res.data
            })

            callback(true)
        })
        .catch(error => {
            console.log("Exception occurred", error);
            callback(false);
        });
};

/*
Set users list for role.
*/
export const setUsersForRole = (roleId, users, callback) => dispatch => {
    const data = {
        id: roleId,
        entityIds: users
    }
    adalApiFetch(Axios, `${API_CONFIG.URL}/user-roles/users`, {
        method: "post",
        data: data
    })
        .then(res => {
            dispatch({
                type: SET_USERS_FOR_ROLE,
                payload: null
            })

            callback(true)
        })
        .catch(error => {
            console.log("Exception occurred", error);
            callback(false);
        });
};


/*
Get roles list for user.
*/
export const getRolesForUser = (userId, callback) => dispatch => {
    adalApiFetch(Axios, `${API_CONFIG.URL}/users/user-roles/${userId}`, {
    method: "get"
    })
        .then(res => {
            dispatch({
                type: GET_ROLES_FOR_USER,
                payload: res.data
            })

            callback(true)
        })
        .catch(error => {
            console.log("Exception occurred", error);
            callback(false);
        });
};

/*
Set roles list for user.
*/
export const setRolesForUser = (userId, roles, callback) => dispatch => {
    const data = {
        id: userId,
        entityIds: roles
    }

    adalApiFetch(Axios, `${API_CONFIG.URL}/users/user-roles`, {
        method: "post",
        data: data
    })
        .then(res => {
            dispatch({
                type: SET_ROLES_FOR_USER,
                payload: null
            })

            callback(true)
        })
        .catch(error => {
            console.log("Exception occurred", error);
            callback(false);
        });
};